import debounce from 'lodash-es/debounce'
import { isInPWA, isIOS } from '@/env';

function setViewportHeight() {
  const vh = isIOS && isInPWA ? window.screen.height * 0.01 : window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}

setViewportHeight();

window.addEventListener('resize', debounce(setViewportHeight, 100, {
  trailing: true,
}));
